<div class="margin-top-30">
  <div>
    <div class="cf margin-top-40">
      <div class="col-lg-8 col-md-8 col-sm-8">
        <div class="row border-l-10 padding-left-32 margin-bottom-60">
          <div class="property-details-box">
            <div class="col-sm-12">
              <h2 class="graylabel margin-top-0 margin-bottom-26">
                <span class="text">
                  Market Data {{property.PropertyName!=null?'-'+property.PropertyName:''}}
                </span>
              </h2>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12">
                <div class="analytics-box-data bluebg-blocks market-data" id="divAnalyticsDetails">
                  <ul class="clearfix">
                    <li *ngFor="let item of analyticsDetails;let i = index">
                      <div class="whiteblock transition">
                        <label class="be-label">{{item.Name}}</label>
                        <div class="clearfix"></div>
                        <h2 *ngIf="!item.Type">{{item.Value}}</h2>
                        <h2 *ngIf="item.Type == 1 ">{{ (item.Value && item.Value != '-') ? ('$'+ Validation.formatCurrencyValues(item.Value)) : '-'}}</h2>
                      </div>
                    </li>
                  </ul>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-l-10 padding-left-32 margin-bottom-60">
          <div class="margin-bottom-20">
            <div class="floatinghead clearfix d-flex margin-bottom-20 margin-top-0 width100">
              <div class="d-flex align-item-center width100">
                <h2 class="graylabel margin-bottom-26" style="margin-top:0 !important;">
                  <span class="text">
                    My {{property.PropertyName}}
                  </span>
                </h2>
                <div class="rightside clearfix ml-auto" *ngIf="property.PropertyStatus=='Portfolio'">
                  <a href="javascript:void(0);" class="link-button" routerLink="/portfolio-principal-property/{{property.Guid}}" [queryParams]="{prevroute:'My Properties',link:router.url, isPortfolio:property.IsPortfolio}" style="color: #198fde">
                    + Edit Property
                  </a>
                </div>
              </div>
            </div>
            <div class="table-fixed table-v2">
              <div class="table-responsive margin0">
                <table class="table basictable row-border hover">
                  <thead>
                    <tr>
                      <th style="width:100px">Tenant Name</th>
                      <th style="width:100px">Address</th>
                      <th style="width:100px">City</th>
                      <th style="width:100px">State</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container>
                      <tr>
                        <td>
                          <p class="blue-label">
                            {{property.PropertyName}}
                          </p>
                        </td>
                        <td>
                          <p>
                            {{property.Address}}
                          </p>
                        <td>
                          <p>
                            {{property.City}}
                          </p>
                        </td>
                        <td>
                          <p class="light-blue-label">
                            {{property.StateCode}}
                          </p>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 padding-l-65 contact-right">


        <div class="border-l-10 padding-left-32" *ngIf="(((this.Authentication.Admin()||this.Authentication.SuperAdmin())&&property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0)||(this.Authentication.Principal()||this.Authentication.Principal1031()||this.Authentication.Seller())) && property.DataEntryPropertyStatusId != 6949">
          <h2 class="graylabel margin-bottom-15">Contact Your Broker Team </h2>
          <ul class="contacts border-div" *ngIf="property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
            <li class="clearfix" *ngFor="let item of property.PropertyContactPersonsList">
              <div *ngIf="item.ContactTypeId != contactType.Others">
                <div class="imgblock">
                  <img [src]="item.Photo != '' ? item.Photo : defaultProfilePic">
                </div>
                <div class="data">
                  <h3>{{item.Name}}<span *ngIf="item.ContactTypeId == contactType.Primary"> - Primary</span></h3>
                  <p>
                    <i class="icon-phone icon"></i>{{item.PhoneNo | phone}}
                  </p>
                  <p>
                    <i class="icon-message icon"></i>{{item.EmailID}}
                  </p>
                  <p *ngIf="item.License != null && item.License != ''">
                    <i class="icon-license icon"></i>{{item.License}}
                  </p>

                  <ul class="d-flex social-links padding0 margin-top-10 margin-bottom-10">
                    <li>
                      <a *ngIf="item.UserLinkedInProfile != null && item.UserLinkedInProfile != ''" target="_blank" href="{{item.UserLinkedInProfile}}"><i class="icon fa fa-linkedin-square" aria-hidden="true"></i></a>
                    </li>
                    <li>
                      <a target="_blank" class="margin-left-10" href="https://www.facebook.com/BeNetLease"><i class="fa fa-facebook-square" aria-hidden="true"></i></a>
                    </li>
                    <li>
                      <a class="margin-left-10" target="_blank" href="https://twitter.com/BeNetLease"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
                    </li>
                    <li> <a class="margin-left-10" target="_blank" href="https://www.instagram.com/benetlease/?igshid=N2ZiY2E3YmU%3D"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
          <div class="text-left" *ngIf="!property.PropertyContactPersonsList || property.PropertyContactPersonsList == undefined || property.PropertyContactPersonsList.length == 0">
            <button *ngIf="(this.Authentication.Principal()||this.Authentication.Principal1031()||this.Authentication.Seller())" class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="contactBroker()">
              Contact Broker
            </button>
          </div>
        </div>


      </div>

    </div>
  </div>
</div>

<div class="margin-top-20">
  <div>
    <div class="price-insight-calculator property-details-box border-l-10 padding-left-32 margin-bottom-40 col-sm-8">
      <h2 class="graylabel margin-bottom-26 margin-top-0">
        <span class="text">
          Pricing Insight Calculator
        </span>
      </h2>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-sm-8 row-left">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel"> Rent/NOI</label>
                <h6 class="displayvalue">
                  {{property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome | number:0) : '-'}}
                </h6>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel">Avg Cap Rate</label>
                <h6 class="displayvalue">
                  {{tenantAvgCapRate!=null?tenantAvgCapRate +'%':'-'}}
                </h6>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel">Remaining Term</label>
                <h6 class="displayvalue">
                  {{property.Remaining_Term}}
                </h6>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel">Escalations</label>
                <h6 class="displayvalue">
                  {{property.RentEscalationPercentage!=null ? property.RentEscalationPercentage + ' %' : '-'}}
                </h6>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel">Escalation Period</label>
                <h6 class="displayvalue">
                  {{property.RentEscalationPeriod!=null&&property.RentEscalationPeriod>0 ? property.RentEscalationPeriod +' Year(s)' : "-"}}
                </h6>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="blocklabel">Total SF</label>
                <h6 class="displayvalue">
                  {{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) : '-'}}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group margin-bottom-15 relative rate-caculator">
            <label class="blocklabel">Input Cap Rate</label>
            <div class="textbox-with-btn textbox-with-2character">
              <span class="inputCapRate">
                <input type="number" [(ngModel)]="inputCapRate" appTwoDigitDecimaNumber (keyup)="onCapRateChange($event)" min=0 step='0.10' class="form-control">
              </span>
             <!--<span class="rightlabel">%</span>-->
            </div>
            <div class="cap-rate-btn">
              <!--<label>%</label>-->
              <a href="javascript:void(0);" class="margin-right-10" (click)="onCalculatedPriceChange(0);"><i class="fa fa-minus" aria-hidden="true"></i></a>
              <a href="javascript:void(0);" (click)="onCalculatedPriceChange(1);"><i class="fa fa-plus" aria-hidden="true"></i></a>
            </div>
          </div>
          <div class="form-group calculated-price rate-caculator">
            <label class="blocklabel">Calculated Price</label>
            <div class="textbox-with-btn-left displayvalue margin-top-15">
              <input type="text" [(ngModel)]="calculatedPrice" value="{{calculatedPrice|number:0}}" dropSpecialCharacters="false" maxlength="18" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"   (keyup)="onAskingPriceChange()" class="form-control">
              <!--<span class="leftlabel">$</span>-->
            </div>
          </div>
          <button class="right-btn btn btn-success btn-lg margin-bottom-5 request-bov-btn" *ngIf="(property.LiveListingId==null||property.LiveListingId==0)&&(property.BovRequestId==0||property.BovRequestId==null) &&(property.DataEntryPropertyStatusId != 6949)" placement="left" (click)="RequestBov();"> REQUEST BOV</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="margin-top-20">
  <div>
    <div class="price-insight-calculator property-details-box border-l-10 padding-left-32 margin-bottom-40 col-sm-8">
      <div class="row">
        <div class="col-sm-8 row-left">
          <div class="row">
            <h2 class="graylabel margin-bottom-26 margin-top-0">
              <span class="text">
                Available Properties
              </span>
            </h2>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="!property.AvailablePropertyApproval&&!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()">
          <div class="form-group margin-bottom-15 relative">
            <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="SendPropertyAccessRequest('Available')">
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row" *ngIf="property!=null&&(property.AvailablePropertyApproval||this.Authentication.Admin()||this.Authentication.SuperAdmin())">
        <div class="col-sm-12 row-left">
          <div class="row">
            <div class="table-fixed table-v2">
              <div class="table-responsive margin0">
                <table class="table basictable row-border hover">
                  <thead>
                    <tr>
                      <th style="width:100px">Tenant Name</th>
                      <th style="width:100px">State</th>
                      <th style="width:100px">City</th>
                      <th style="width:100px">Asking Price</th>
                      <th style="width:100px" *ngIf="(!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&Is1031Accessed==false)">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let availableProp of AvailableProperties;let i = index ">
                      <td *ngIf="!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&availableProp.PropertyForId!=602">
                        <p class="blue-label">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{availableProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{availableProp.Name}}</a>
                        </p>
                      </td>
                      <td *ngIf="!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&availableProp.PropertyForId==602">
                        <p *ngIf="(availableProp.AccessAdded==null||availableProp.AccessAdded==0)">
                          {{availableProp.Name}}
                        </p>
                        <p class="blue-label" *ngIf="(availableProp.AccessAdded>0)">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{availableProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{availableProp.Name}}</a>
                        </p>
                      </td>
                      <td *ngIf="this.Authentication.Admin()||this.Authentication.SuperAdmin()">
                        <p class="blue-label">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{availableProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{availableProp.Name}}</a>
                        </p>
                      </td>
                      <td>
                        <p>
                          {{availableProp.State}}
                        </p>
                      <td>
                        <p>
                          {{availableProp.City}}
                        </p>
                      </td>

                      <td>
                        <p *ngIf="availableProp.Unpriced" class="whitespacenowrap">Unpriced</p>
                        <p *ngIf="!availableProp.Unpriced" class="whitespacenowrap">{{(availableProp.Price) ? '$ '+ (availableProp.Price | number:0) : '-'}}</p>
                      </td>
                      <td *ngIf="(!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&Is1031Accessed==false)">
                        <button class="btn btn-success btn-lg" tooltip="Request for Broker" *ngIf="(availableProp.AccessAdded==null||availableProp.AccessAdded==0)&&availableProp.PropertyForId==602" (click)="Send1031AccessRequest(availableProp.Id,'Available')">Request for Broker</button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="AvailableProperties?.length == 0 ">
                      <td colspan="12" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

            </div>
          </div>

        </div>
        <div>
        </div>
      </div>
      <div class="row div2" *ngIf="!property.AvailablePropertyApproval&&!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()">
        <div class="col-sm-8 row-left">
          <div class="row">
            <h5>Click on Learn More to gain access to available properties in B+E.</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="margin-top-20">
  <div>
    <div class="price-insight-calculator property-details-box border-l-10 padding-left-32 margin-bottom-40 col-sm-8">
      <div class="row">
        <div class="col-sm-8 row-left">
          <div class="row">
            <h2 class="graylabel margin-bottom-26 margin-top-0">
              <span class="text">
                Off-Market Properties
              </span>
            </h2>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="!property.OfferMarketPropertyApproval&&!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()">
          <div class="form-group margin-bottom-15 relative">
            <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="SendPropertyAccessRequest('Off-Market')">
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row" *ngIf="property!=null&&(property.OfferMarketPropertyApproval||this.Authentication.Admin()||this.Authentication.SuperAdmin())">
        <div class="col-sm-12 row-left">
          <div class="row">
            <div class="table-fixed table-v2">
              <div class="table-responsive margin0">
                <table class="table basictable row-border hover">
                  <thead>
                    <tr>
                      <th style="width:100px">Tenant Name</th>
                      <th style="width:100px">State</th>
                      <th style="width:100px">City</th>
                      <th style="width:100px" *ngIf="(!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&Is1031OffMarketAccessed==false)">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let offMarketProp of OffMarketProperties;let i = index ">
                      <td *ngIf="!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&offMarketProp.PropertyForId!=602">
                        <p class="blue-label">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{offMarketProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{offMarketProp.Name}}</a>
                        </p>
                      </td>
                      <td *ngIf="!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&offMarketProp.PropertyForId==602">
                        <p *ngIf="(offMarketProp.AccessAdded==null||offMarketProp.AccessAdded==0)">
                          {{offMarketProp.Name}}
                        </p>
                        <p class="blue-label" *ngIf="(offMarketProp.AccessAdded>0)">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{offMarketProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{offMarketProp.Name}}</a>
                        </p>
                      </td>
                      <td *ngIf="this.Authentication.Admin()||this.Authentication.SuperAdmin()">
                        <p class="blue-label">
                          <a href="javascript:void(0);" routerLink="/viewproperty/{{offMarketProp.Guid}}" [queryParams]="{'prevroute':'Portfolio Property Detail',link:router.url}">{{offMarketProp.Name}}</a>
                        </p>
                      </td>
                      <td>
                        <p>
                          {{offMarketProp.State}}
                        </p>
                      <td>
                        <p>
                          {{offMarketProp.City}}
                        </p>
                      </td>
                      <td *ngIf="(!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()&&Is1031OffMarketAccessed==false)">
                        <button class="btn btn-success btn-lg" tooltip="Ask for Price" (click)="Send1031AccessRequest(offMarketProp.Id,'Off-Market')" *ngIf="(offMarketProp.AccessAdded==null||offMarketProp.AccessAdded==0)&&offMarketProp.PropertyForId==602">Ask for Price</button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="OffMarketProperties?.length == 0 ">
                      <td colspan="12" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

            </div>
          </div>

        </div>
        <div>
        </div>
      </div>
      <div class="row div2" *ngIf="!property.OfferMarketPropertyApproval&&!this.Authentication.Admin()&&!this.Authentication.SuperAdmin()">
        <div class="col-sm-8 row-left">
          <div class="row">
            <h5>Click on Learn More to gain access to off-market properties in B+E.</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
